import * as React from 'react';

import { IUserExtension } from '@ClientModels/userExtension';

interface IUserAutoCompleteProps {
  props: any;
  option: IUserExtension;
}

export const UserAutoCompleteDisplay: React.FC<IUserAutoCompleteProps> = ({ props, option }) => {
  return (
    <li {...props} key={`${option.displayName} ${option.email}`}>
      <span>
        {option.displayName} <br />
        <small>{option.email}</small>
      </span>
    </li>
  )
}
